import OfferEvent from '@core/models/offer/OfferEvent';
import { logger } from '@superbet-group/web.lib.utilities';

export function createOfferEventGetter(getEventsMap: () => Record<string, OfferEvent>, getEvent: (eventId: OfferEvent['id']) => Promise<unknown>) {
    return async (eventId: OfferEvent['id']): Promise<OfferEvent | undefined> => {
        const eventsMap = getEventsMap();

        // Do a best effort to try to get the event from the store, to avoid the UI
        // being broken. Worst case: Repeated relatively cheap requests to the backend
        // every 5 or so seconds. If we get a lot of errors in that direction, we can
        // add a layer that tracks failures and handles them in a more sophisticated way.
        const storedEvent = eventsMap[eventId];

        // Since we're dealing with custom odds, we need to make sure we have the _full_ event
        // odd list to reconstruct the market name. If we don't have it, we need to refetch it.
        if (!storedEvent || !storedEvent.containsFullOddList()) {
            try {
                await getEvent(eventId);
            } catch (error) {
                logger.error(error as Error);
            }
        }

        return eventsMap[eventId];
    };
}
